export const AnalyzerListingStateMapping = {
  TRUE: ['In use', 'palette.accent.blue.light'],
  FALSE: ['Not in use', 'palette.neutral.light'],
};
